module.exports = __webpack_public_path__ + "static/media/leftGray.c752aeda.svg";